<template>
    <div class="ix-formbuilder-component-summary-content">

        <div class="formbuilder-component boxed padding" v-if="displayMode == 'readable' || displayMode == 'fillable'">
            <div class="mb-small">
                <p class="formbuilder-component-label">{{ currentField.label }}</p>
                <p class="formbuilder-component-help" v-if="currentField.helper">{{ currentField.helper }}</p>
            </div>


                    
            <div class="formbuilder-doc-preview" style="display: flex; overflow:scroll" v-if="currentField.files && currentField.files.length">
                <div class="formbuilder-document" v-for="(file,index) in currentField.files" :key="index">
                    <template  v-if="['jpg', 'png', 'jpeg'].includes(file.extension.toLowerCase())">
                        <img :src="file.document_path"/>
                        <p class="formbuilder-document-name">{{ file.filename.substring(0,15) }}</p>
                    </template>
                </div>
            </div>

            <div v-if="getUnpreviewableFiles(currentField.files).length > 0">
                Autres documents
                <ul>
                    <li v-for="(file,index) in getUnpreviewableFiles(currentField.files)" :key="index">
                        <a :href="file.document_path" target="_blank">{{ file.filename.substring(0,15) }}</a>
                    </li>
                </ul>
            </div>
            <span v-if="currentField.files && currentField.files.length == 0">Il n'y a pas de documents disponibles</span>
        </div>

        <div v-if="displayMode == 'summary'" class="ix-formbuilder-component-summary-info">
            <div class="ix-formbuilder-component-summary-handle">
                <span class="ix-drag-icon handle-line"></span>
            </div>
            <div class="ix-formbuilder-component-summary-icon" data-toggle="tooltip" data-placement="top" title="Annexes">
                <div class="ix-formbuilder-icon">
                    <i class="far fa-file"></i>
                </div>
            </div>
            <div class="ix-formbuilder-component-summary-content">
                <span class="ix-formbuilder-component-summary-label">{{ currentField.label }}</span>
                <ul class="ix-formbuilder-component-summary-options">
                    <li>Afficher les images dans le pdf : {{ currentField.show_pdf ? 'Oui' : 'Non' }}</li>
                </ul>
                <table class="ix-table" v-if="currentField.files.length > 0">
                    <tbody>
                        <tr v-for="(file , index) in currentField.files">
                            <td>
                                <a :href="file.document_path" target="_blank" v-html="truncate(file.filename, 50)"></a>
                                <button type="button" class="ix-btn ix-btn-xsmall transparent ix-btn-icon" @click="removeFile(file,index)" :disabled="loadingDelete">
                                    <i class="far fa-times"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: "AppendicesComponent",
        props: ['currentField', 'showIcon' , 'displayMode'],
        data() {
            return {
                headers : this.getHttpJsonRequestHeaders(),
                accept: 'image/png,image/gif,image/jpeg,pdf',
                extensions: ['gif','jpg','jpeg','png'],
                postAction: '/api/upload',
                getAction: '/api/downloadFile',
                files : [],
                uploadFiles : [],
                callbackMessage : '',
                successUpload: null,

                loading : false,
                loadingDelete : false,
            }
        },
        mounted() {
            this.currentField.files = this.currentField.files ? this.currentField.files : [];
        },
        methods : {
            async onFileSelected(event){
                this.files = event.target.files;
                await this.onUpload();
                this.files = [];
            },
            async onUpload(){
                this.loading = true;
                const API = $('meta[name="api-token"]').attr('content');
                const config = {
                    headers: {
                        "Content-Type": 'multipart/form-data',
                        "X-Requested-With": "XMLHttpRequest",
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${API}`,
                    }
                }

                let formData = new FormData();
                for(let i=0; i < this.files.length; i++){
                    formData.append("files["+i+"]", this.files[i]);
                }
                axios.post(this.postAction, formData , config).then((data) => {
                    this.loading = false;
                    
                    if(data){
                        this.uploadFiles = data.data;
                        this.callbackMessage = 'Les fichiers ont bien été enregistrés.'
                        this.successUpload = true;
                        this.currentField.files.push(...this.uploadFiles);
                        this.files = [];
                    }
                }).catch((error) => {
                    this.callbackMessage = 'Une erreur serveur est survenus.'
                    this.successUpload = false;
                    this.loading = false;
                })

            },
           removeFile(file , index){
                this.loadingDelete = true;

                 this.$swal({
                    title : "Êtes vous sûr ?",
                    text : "Le fichier sera définitivement supprimé",
                    icon : "warning",
                    dangerMode : true,
                    buttons : ["Annuler" , "Supprimer"]
                }).then((willDo) => {
                    if(willDo){
                        fetch('/api/destroyFile?file_id='+file.id, {
                            ...{
                                method: 'DELETE'
                            },
                            ...this.getHttpJsonRequestHeaders(),
                        }).then(async (response) => {
                            if(response.ok)
                                this.currentField.files.splice(index , 1);

                            this.loadingDelete = false

                        }).catch(error => {
                            this.loadingDelete = false
                            console.log(error);
                        })
                    }
                });
            },
            getUnpreviewableFiles(files){
                return files.filter(file => {
                    return !['jpg', 'png', 'jpeg'].includes(file.extension.toLowerCase());
                })
            }
        },
    }
</script>
